import { FC, useState, ChangeEvent } from 'react';
import { useStyles } from './styles';
import { Grid, Paper, Tabs, Tab } from '@material-ui/core';
import TabPanel from 'components/TabPanel';
import ServiceTable from './ServiceTable';
import FederationTable from './FederationTable';
import ThirdPartyTable from './ThirdPartyTable';
import ProviderTable from './ProviderTable';
function a11yProps(index: string) {
  return {
    id: `wrapped-tab-${index}`,
    'aria-controls': `wrapped-tabpanel-${index}`,
  };
}

const SamlTable: FC = () => {
  const classes = useStyles();
  const [value, setValue] = useState<string>('one');
  const handleChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setValue(newValue);
  };

  return (
    <Grid item xl className={classes.tabsPanel}>
      <Paper className={classes.tabsPaper}>
        <div className={classes.tabsContainer}>
          <Tabs
            value={value}
            className={classes.tabs}
            TabIndicatorProps={{ style: { color: 'transparent', background: 'transparent' } }}
            onChange={handleChange}
            variant='scrollable'
            scrollButtons='auto'
          >
            <Tab value='one' wrapped label='Service Providers' {...a11yProps('one')} className={classes.label} />
            <Tab value='two' wrapped label='Federation' {...a11yProps('two')} className={classes.label} />
            {/* <Tab value='three' wrapped label='Third-Party IdP' {...a11yProps('three')} className={classes.label} /> */}
            <Tab value='three' wrapped label='Identity Provider ' {...a11yProps('three')} className={classes.label} />
          </Tabs>
        </div>
        <div>
          <TabPanel value={value} index='one'>
            <ServiceTable />
          </TabPanel>
          <TabPanel value={value} index='two'>
            <FederationTable />
          </TabPanel>
          {/* <TabPanel value={value} index='three'>
            <ThirdPartyTable />
          </TabPanel> */}
          <TabPanel value={value} index='three'>
            <ProviderTable />
          </TabPanel>
        </div>
      </Paper>
    </Grid>
  );
};
export default SamlTable;
